import { BehaviorContext } from '../../behavior-context';
import { Behavior } from '../../behavior';
import { Injectable } from '@angular/core';

@Injectable()
export class TemplateGoToPage implements Behavior {
  execute(args: { pageKey: string }, context: BehaviorContext): Promise<any> {
    return context.get('template').goToPage(args.pageKey);
  }
}
